export const LOCALE_COOKIE_NAME = "prod-edx-language-preference" as const;

/** One day in seconds */
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24;

export const LOCALE_COOKIE_PATH = "/" as const;

export const LOCALE_COOKIE_DOMAIN_DEFAULT = ".edx.org" as const;

export const LOCALE_TO_COOKIE_MAP: Record<string, string> = {
  es: "es-419",
  en: "en",
} as const;

/**
 * Request header set by the CloudFront locale Lambda when it rewrites the
 * origin URI to `/es…` from a bare path (browser URL stays unprefixed).
 */
export const SPANISH_LOCALE_REWRITE_HEADER =
  "x-edx-spanish-locale-rewrite" as const;

/**
 * Request header carrying the resolved pathname, set by middleware. Layouts
 * only receive their own route params, so resolving the document locale needs
 * the full path handed over explicitly.
 */
export const PATHNAME_HEADER = "x-edx-pathname" as const;
